<template>
  <section class="c-crypto-reports">
    <FilterTransactions
      @onSubmitFilter="handleFilter"
      title="فیلتر تریدها"
      :fromAssets="$store.getters.getAvailableNoneFiatAssets"
      :toAssets="$store.getters.getAvailableNoneFiatAssets"
      :from="true"
      :to="true"
    />
    <card class="data-card" :show-footer-line="true">
      <b-row no-gutters>
        <b-col no-gutters>
          <h1 class="card-header p-0 card-header-text pb-3">ترید رمزارزها</h1>
        </b-col>
      </b-row>
      <b-skeleton-table
        v-if="loading"
        :rows="10"
        :columns="4"
        :table-props="{ bordered: true, striped: true }"
      >
      </b-skeleton-table>
      <b-row v-if="!loading">
        <b-col class="no-col-margin" md="12">
          <!-- <h1 class="section-header">کیف های پول</h1> -->
          <b-card class="history-table" no-body>
            <b-table
              responsive
              emptyText="تاریخچه ای یافت نشد"
              :items="histories"
              :fields="fields"
              stacked="lg"
              :per-page="this.filterData.pageSize"
              show-empty
              small
            >
              <template #cell(status)="row">
                <b-button size="sm" variant="outline-primary">
                  {{ getText(row.item.status) }}
                </b-button>
              </template>

              <!-- <template #cell(serviceFee)="row">
                  {{ row.item.serviceFee }}
                </template> -->

              <template #cell(fromAsset)="row">
                <div style="display: flex">
                  <CryptoIcons
                    class="ml-3"
                    :symbol="row.item.fromAsset"
                    size="30"
                  />

                  <span class="pt-1">{{ row.item.fromAsset }}</span>
                </div>
              </template>

              <template #cell(fromAmount)="row">
                {{ fixDecimal(row.item.fromAmount) }}
              </template>

              <template #cell(toAmount)="row">
                {{ fixDecimal(row.item.toAmount) }}
              </template>

              <template #cell(serviceFee)="row">
                {{ fixDecimal(row.item.serviceFee) }}
              </template>
              serviceFee

              <template #cell(toAsset)="row">
                <div style="display: flex">
                  <CryptoIcons
                    class="ml-3"
                    :symbol="row.item.toAsset"
                    size="30"
                  />

                  <span class="pt-1">{{ row.item.toAsset }}</span>
                </div>
              </template>

              <template #cell(date)="row">
                {{ faDateTime(row.item.date) }}
              </template>

              <template #cell(actions)>
                <b-row no-gutters>
                  <b-col md="3" cols="6">
                    <b-link size="sm" class="mr-1"> مشاهده</b-link>
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-card>
          <div v-if="!dashView" class="paginationNav">
            <b-row>
              <b-col class="mt-4">
                <div class="overflow-auto">
                  <BasePagination
                    :showNext="showNext"
                    :showPrev="currentPage !== 0"
                    @onClick="handlePaginationClick"
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </card>
  </section>
</template>
<script>
import http from "@/httpservices/HttpService"
import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import FilterTransactions from "@/components/FilterTransactions";
import dateHelper from "@/utils/DateHelper";
import store from "@/store";

export default {
  props: {
    dashView: {
      type: Boolean,
      default: false,
      description: "Wethere it is displayed in dashboard",
    },
  },

  mixins: [filterAndPaginate],

  components: {
    CryptoIcons,
    FilterTransactions,
    BasePagination,
  },

  data() {
    return {
      fields: [
        {
          key: "status",
          label: "وضعیت",
          sortDirection: "desc",
        },
        {
          key: "fromAsset",
          label: "از",
          sortDirection: "desc",
        },
        {
          key: "fromAmount",
          label: "مقدار ارز مبدا",
          sortDirection: "desc",
        },
        {
          key: "toAsset",
          label: "به",
          sortDirection: "desc",
        },
        {
          key: "toAmount",
          label: "مقدار دریافتی",
          sortDirection: "desc",
        },
        {
          key: "serviceFee",
          label: "فی",
        },
        {
          key: "date",
          label: "تاریخ",
        },

        // { key: "actions", label: "" },
      ],
      histories: [],
      loading: false,

      userBoxArrow: "chevron-down",
    };
  },

  computed: {
    adminsAccessOnly() {
      return Boolean(store.getters['isSuperAdmin']);
    }
  },

  mounted() {
    this.toggle_icon();
    this.getHistory();
  },

  methods: {
    faDateTime(d) {
      return dateHelper.faDateTime(d);
    },

    getHistory() {
      this.loading = true;

      const url = this.adminsAccessOnly
        ? process.env.VUE_APP_BASE_URL +
        "/AdminReports" +
        "/orders/page/" +
        this.currentPage +
        "?AccountId=" +
        this.$route.params.id +
        `&Start=${this.filterData.fromDate}&End=${this.filterData.toDate}&FromSymbol=${this.filterData.fromSymbol}&ToSymbol=${this.filterData.toSymbol}&PageSize=${this.filterData.pageSize}`

        : process.env.VUE_APP_BASE_URL +
        "/AdminReports" +
        "/orders/"+this.$route.params.id+"/page/" +
        this.currentPage +
        "?AccountId=" +
        this.$route.params.id +
        `&Start=${this.filterData.fromDate}&End=${this.filterData.toDate}&FromSymbol=${this.filterData.fromSymbol}&ToSymbol=${this.filterData.toSymbol}&PageSize=${this.filterData.pageSize}`;

      http.get(url)
        .then((response) => {
          this.histories = response.data.data;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
          //this.$router.push("/500");
        });
    },

    getText(text) {
      if (text == "Filled") {
        return "تکمیل شده";
      }
    },

    toggle_icon() {
      this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
        if (isJustShown == true) {
          this.userBoxArrow = "chevron-up";
        } else {
          this.userBoxArrow = "chevron-down";
        }
      });
    },
  },
};
</script>
<style lang="scss">
.c-crypto-reports {
  .history-table {
    direction: rtl;
    text-align: center;
  }
}
</style>
